import * as api from '~/api/resource'
import Vue from 'vue'

export const state = {
    lists: {},
    updateTick: 0,
    repoConfigs: {
        readings: {processor: 'fuels/readings', request: {limit: 0}},
        fuelSrs: {type: 'tanks', request: {sort: 'name', limit: 0}},
        fuelSappliers: {type: 'contacts', request: {contactTypes: 'fuelsapplier', sort: 'name', limit: 0}},
        vehicleTypes: {processor: 'gears/getoptions', request: {propVal: 'type', model: 'Assets'}},
//{type: 'assets', request: {propGroup: 'type'}},
        vehicleGroups: {processor: 'gears/getoptions', request: {propVal: 'vgroup', model: 'Assets'}},
        // {type: 'assets', request: {propGroup: 'vgroup'}},
        vehicleNotificationTypes: {processor: 'gears/getoptions', request: {propVal: 'type', model: 'FuelDrafts'}},
        drivers: {type: 'contacts', request: {contactTypes: 'driver', sort: 'name', limit: 0}},
        vehicles: {
            type: 'assets',
            limit: 0,
            request: {
                compact: true,
                sort: 'name',
                archiveLevel: [1,
                    0]
            }
        }
    }
}

export const getters = {
    getList: state => list => state.lists[list],
    updateTick: state => state.updateTick
}

export const mutations = {
    setlist(state, {type, list}) {

        if (_.isArray(list))
            state.lists[type] = list.map(function (op) {
                if (op.id) op.id = op.id + ""
                return op
            })
        else
            // for (const key in list) {
            //     if (list.hasOwnProperty(key)) {
            //         const sublist = list[key];
            //         state.lists[type + '_' + key] = sublist.map(function (op) {
            //             if (op.id) op.id = op.id + ""
            //             return op
            //         })
            //     }
            // }
            Vue.set(state.lists, type, list)
        // state.lists[type] = list
        ++state.updateTick
        // _log_('>>>MM>', state)
    },
}

export const actions = {
    async fetchAll({commit, state}, types) {
        // _log_('gochkkk--', types)

        //this is for auto tags
        if (types?.length)
            for (let i = 0; i < types.length; i++) {
                const tp = types[i]// 'gears/getoptions', request: {propVal: 'type',model:'Assets'
                if (tp.includes(':')) {
                    const tpPrts = tp.split(':')
                    const {data} = await api.fetchProcessor('gears/getoptions', {propVal: tpPrts[1], model: tpPrts[0]})


                    commit('setlist', {
                        type: tp,
                        list: data.results
                    })
                }


            }
        const confs = state.repoConfigs
        for (const key in confs) {
            // _log_('go..' + key, types)
            if (confs.hasOwnProperty(key) && (!types || types.indexOf(key) >= 0)) {
                const conf = confs[key];
                if (conf.type) {
                    const {data} = await api.fetchList(conf.type, conf.request)

                    commit('setlist', {
                        type: key,
                        list: data.results
                    })
                }
                if (conf.processor) {
                    const {data} = await api.fetchProcessor(conf.processor, conf.request)


                    commit('setlist', {
                        type: key,
                        list: data.results
                    })
                }

            }


        }

    },
    async fetch({commit, state}, type) {
        _log_('go..', type)
        if (!type) return Promise.reject(new Error('No list type given'))
        if (state.lists[type]) return state.lists[type]
        commit('setlist', {
            type: type,
            list: []
        })
        _log_('go..star', type)
        const conf = state.repoConfigs[type] ? state.repoConfigs[type] : {type: type}
        const {data} = await api.fetchList(conf.type, conf.request)
        commit('setlist', {
            type: type,
            list: data.results
        })
        return data.results
    },
}
